module.exports = __webpack_public_path__ + "img/safetyImg3.e8fdfe99.png";